import {ApiClient} from '@hconnect/apiclient'
import {useUpmPlantContext} from '@hconnect/upm'
import {useQuery} from '@tanstack/react-query'

import type {AssetCapacity} from '../../interfaces'
import type {MomentRange} from '../../types'

export const ASSET_CAPACITY_QUERY_KEY = 'assetCapacity'

interface AssetCapacityResponse {
  assets: Record<string, AssetCapacity>
}

const fetchAssetsCapacity = async (
  plantCode: string,
  from: string,
  to: string,
  signal?: AbortSignal
): Promise<AssetCapacityResponse> => {
  const response = await ApiClient.axiosInstance.get<AssetCapacityResponse>(
    `/plants/${plantCode}/schedules/kpi/asset-capacity`,
    {params: {from, to}, signal}
  )
  return response.data
}

export const useAssetsCapacity = ([from, to]: MomentRange) => {
  const {plantId: plantCode} = useUpmPlantContext()
  const fromIso = from.toISOString()
  const toIso = to.toISOString()

  return useQuery<AssetCapacityResponse, unknown, Record<string, AssetCapacity>>({
    queryKey: [ASSET_CAPACITY_QUERY_KEY, plantCode, {from: fromIso, to: toIso}],
    queryFn: ({signal}) => fetchAssetsCapacity(plantCode, fromIso, toIso, signal),
    select: (data) => data.assets,
    throwOnError: true
  })
}
